import React from 'react';
import './About.styles.scss';

export function About() {
  return (
    <article className="about-article">
      <div className="about-photo"></div>
      <div className="main-content-text">
        <p>
          Nazywam się <b>Magdalena Pawlak</b> i&nbsp;jestem radcą prawnym
          prowadzącym Kancelarię Radcy Prawnego we&nbsp;Wrocławiu. Specjalizuję
          się w&nbsp;
          <b>sprawach odszkodowawczych, prawie spadkowym i&nbsp;rodzinnym</b>,
          a&nbsp;także w&nbsp;sprawach dotyczących kredytów frankowych. Jestem
          absolwentką Wydziału Prawa, Administracji i&nbsp;Ekonomii Uniwersytetu
          Wrocławskiego. Studia prawnicze ukończyłam w&nbsp;trybie dziennym,
          a&nbsp; następnie odbyłam aplikację radcowską w&nbsp;Okręgowej Izbie
          Radców Prawnych we&nbsp;Wrocławiu. Już&nbsp;w&nbsp;czasie studiów
          byłam stypendystką dla najlepszych studentów, a&nbsp;zdobytą wiedzę
          przekładam na&nbsp;praktykę zawodową. Biegle posługuję się językiem
          angielskim, ukończyłam również specjalistyczne kursy z&nbsp;zakresu{' '}
          <b>prawniczego języka angielskiego</b>. Przez lata pracowałam
          we&nbsp;wrocławskich kancelariach radcowskich i&nbsp;adwokackich,
          zdobywając doświadczenie w&nbsp;sprawach <b>cywilnych</b>,{' '}
          <b>administracyjnych</b>,<b> rodzinnych</b>,{' '}
          <b>pracowniczych oraz&nbsp;karnych</b>. Obecnie pomagam zarówno{' '}
          <b>osobom fizycznym, jak&nbsp;i&nbsp;przedsiębiorcom</b>, oferując
          wsparcie dostosowane do&nbsp;indywidualnych potrzeb klienta.
        </p>
        <h3>Jak pracuję?</h3>
        <p>
          <ul>
            <li>
              Każdą sprawę analizuję{' '}
              <b>indywidualnie i&nbsp;z&nbsp;najwyższą starannością</b>.
            </li>
            <li>
              W pierwszej kolejności staram się znaleźć{' '}
              <b>polubowne rozwiązanie</b>, aby&nbsp;uniknąć kosztownego
              i&nbsp;długotrwałego procesu sądowego.
            </li>
            <li>
              Jeśli interesy klienta tego wymagają,{' '}
              <b>skutecznie reprezentuję go&nbsp;przed sądem</b>.
            </li>
            <li>
              Regularnie informuję klienta o&nbsp;przebiegu sprawy, zapewniając{' '}
              <b>transparentną komunikację</b>.
            </li>
            <li>
              W razie potrzeby współpracuję z&nbsp;
              <b>notariuszami i&nbsp;doradcami podatkowymi</b>, by&nbsp;zapewnić
              kompleksową obsługę.
            </li>
            <li>
              Mając na&nbsp;względzie znaczenie sprawy dla Klienta, oferuję
              porady prawne <b>w&nbsp;tym samym dniu</b>.
            </li>
          </ul>
        </p>
        <p>
          Prowadzę również wykłady i&nbsp;szkolenia z&nbsp;zakresu prawa
          cywilnego.
        </p>
        <h3>Prywatnie</h3>
        <p>
          W wolnym czasie podróżuję, oglądam dobre kino i&nbsp;gram na&nbsp;
          fortepianie. Uwielbiam także powieści kryminalne.
        </p>
      </div>
    </article>
  );
}
